import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { FaCar, FaSitemap } from 'react-icons/fa';
import { HiOutlineRectangleGroup } from 'react-icons/hi2';
import { useDispatch } from 'react-redux';
import { vehicleGroupService } from '../../Services/vehicle.group.service';
import { vehicleService } from '../../Services/vehicle.service';
import { useSelected } from '../../contexts/SelectedContext';
import { Filters } from '../../components/Filters';
import SyncFusionDateTimePicker from '../Components/SyncFusionDateTimePicker/SyncFusionDateTimePicker';
import { TbFileTypePdf, TbFileTypeXls, TbStatusChange } from 'react-icons/tb';

export const MaintenanceCompleted = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch(); /** eslint-disable-next-line */
    dispatch({ type: "title", value: t("MAINTENANCES.COMPLETED.TITLE") });

    // SelectedContext
    const { selectedValues } = useSelected();
    const selectedGroup = selectedValues.veiculos?.[0] || 0;

    const [vehicleGroups, setVehicleGroups] = useState([]);
    const [vehicles, setVehicles] = useState([]);
    const [filtersLoading, setFiltersLoading] = useState(false);
    const [isLoadingVehicles, setIsLoadingVehicles] = useState(false);

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);


    const fetchVehicleGroups = async () => {
        try {
            setFiltersLoading(true);
            const groups = await vehicleGroupService.fetchGroups();

            // Garante que sempre seja um array, mesmo quando a API retorna erro
            if (Array.isArray(groups)) {
                setVehicleGroups(groups);
                if (groups.length === 1) {
                    await fetchVehiclesByGroup(groups[0].vehicleGroupId);
                } else {
                    await fetchVehiclesByGroup(0);
                }
            } else {
                // Se retornou null, undefined ou objeto de erro, define como array vazio
                setVehicleGroups([]);
                if (groups?.error) {
                    console.log("Erro ao buscar grupos:", groups.message || groups.friendlyMessage);
                }
                await fetchVehiclesByGroup(0);
            }
        } catch (error) {
            console.log(error);
            setVehicleGroups([]);
        } finally {
            setFiltersLoading(false);
        }
    };

    const fetchVehiclesByGroup = async (groupId) => {
        setIsLoadingVehicles(true);
        try {
            const vehicles = await vehicleService.fetchVehicles(groupId);
            // Garante que sempre seja um array, mesmo quando a API retorna erro
            if (Array.isArray(vehicles)) {
                setVehicles(vehicles);
            } else {
                // Se retornou null, undefined ou objeto de erro, define como array vazio
                setVehicles([]);
                if (vehicles?.error) {
                    console.log("Erro ao buscar veículos:", vehicles.message || vehicles.friendlyMessage);
                }
            }
        } catch (error) {
            console.log(error);
            setVehicles([]);
        } finally {
            setIsLoadingVehicles(false);
        }
    };

    // Carrega veículos quando o grupo selecionado muda
    useEffect(() => {
        if (selectedGroup !== null && selectedGroup !== undefined) {
            fetchVehiclesByGroup(selectedGroup);
        }
    }, [selectedGroup]);

    useEffect(() => {
        fetchVehicleGroups();
    }, []);


    return (
        <div className='ml-4'>
            <p>{t("MAINTENANCES.COMPLETED.DESCRIPTION")}</p>
            <div className="filter-maintenance">
                <Filters
                    id={"veiculos"}
                    isMulti={false}
                    title={t("VIEW_MAP_FILTERS.GROUPS")}
                    hasSubTitle={true}
                    subTitle={t("VIEW_MAP_FILTERS.ALL_GROUPS")}
                    options={vehicleGroups || []}
                    icon={HiOutlineRectangleGroup}
                    hasIcon={true}
                    pageTitle={"maintenances_scheduling"}
                />
                <Filters
                    id={"veiculosGroups"}
                    isMulti={false}
                    title={t("VIEW_MAP_FILTERS.VEHICLES")}
                    hasSubTitle={true}
                    subTitle={t("VIEW_MAP_FILTERS.ALL_VEHICLES")}
                    options={vehicles || []}
                    icon={FaCar}
                    hasIcon={true}
                    pageTitle={"maintenances_scheduling"}
                    isLoading={isLoadingVehicles}
                />

                <div className="field">
                    <div className="field-data">
                        <SyncFusionDateTimePicker
                            id="datetimepickerStart"
                            value={startDate}
                            onChange={setStartDate}
                            placeholder={t("SEARCH.INITIAL_DATE_TIME")}
                            step={30}
                        />
                    </div>
                    <span>{t("MAINTENANCES.COMPLETED.UNTIL")}</span>
                    <div className="field-data">
                        <SyncFusionDateTimePicker
                            id="datetimepickerStart"
                            value={endDate}
                            onChange={setEndDate}
                            placeholder={t("SEARCH.INITIAL_DATE_TIME")}
                            step={30}
                        />
                    </div>
                </div>
                <button className="btn btn-primary">{t("MAINTENANCES.COMPLETED.SEARCH")}</button>
            </div>

            <div className="buttons-pending">
                <button className="btn btn-primary">
                    <TbFileTypeXls />
                    Excel
                </button>
                <button className="btn btn-secondary">
                    <TbFileTypePdf />
                    PDF
                </button>
            </div>
        </div>
    )
}
